
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';
import Spinner from 'global/Loading/SecondarySpinner';

const ArticleLayout = dynamic(
  () => import('features/static/UserArticleLayout'),
);
const Contact = dynamic(() => import('features/contact'), {
  loading: () => <Spinner />,
});
const ContactContent = dynamic(() => import('constants/contents/contact'));

interface ContactPageProps {
  isLoggedIn: boolean;
}

const ContactPage = ({ isLoggedIn }: ContactPageProps) => {
  if (isLoggedIn) {
    return <ArticleLayout source={<ContactContent />} title="Contact" />;
  }

  return <Contact />;
};

export async function getServerSideProps(context) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  return {
    props: {
      isLoggedIn,
    },
  };
}

export default ContactPage;
